import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnamePlanList extends BaseModelAPI {

	static entity = 'stockopnameplanlist'
	static entityName = 'stockopnameplan';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
